// extracted by mini-css-extract-plugin
module.exports = {"threeDots":"styles_threeDots__2MJ_1","content":"styles_content__3i2SW","item":"styles_item__Lyarr"};